export default __webpack_public_path__ + "static/media/paidMedia.89595d48.svg";